import { indexFingerCover } from './indexFingerCover'
import { indexFingerPad, indexFingerPadWithNoEdge } from './indexFingerPad'

export const fingerGuardDrawer = async (
  ctx: CanvasRenderingContext2D,
  fingerGuardType: string,
  indexCoverColor: string,
  stitchColor: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  if (fingerGuardType === 'indexPad') {
    await indexFingerPad(ctx, indexCoverColor, stitchColor, printLeatherTypeValue)
  }
  if (fingerGuardType === 'indexPadWithNoEdge') {
    await indexFingerPadWithNoEdge(ctx, indexCoverColor, stitchColor, printLeatherTypeValue)
  }
  if (fingerGuardType === 'indexCover') {
    await indexFingerCover(ctx, indexCoverColor, stitchColor, printLeatherTypeValue)
  }
}
